import { useCallback } from 'react';
import { useUserSession } from './useUserSession';
import { premiumService } from '../services/premiumService';

/**
 * Hook pour le statut premium (et période d'essai) de l'utilisateur.
 * Les champs premium viennent de la session (verify) ; permet d'activer l'essai et de rafraîchir.
 */
export function usePremiumStatus() {
  const { user, refreshSession } = useUserSession();

  const isPremium = Boolean(user?.premium);
  const trialEndsAtRaw = user?.trialEndsAt || null;
  const isTrial = Boolean(
    trialEndsAtRaw && new Date(trialEndsAtRaw) > new Date()
  );
  const hasPremiumAccess = isPremium || isTrial;
  const eligibleForTrial = Boolean(user?.eligibleForTrial);
  const premiumExpiresAt = user?.premiumExpiresAt || null;
  const trialEndsAt = trialEndsAtRaw;

  const requestTrial = useCallback(async () => {
    return premiumService.requestTrial();
  }, []);

  const activateTrial = useCallback(async () => {
    const result = await premiumService.activateTrial();
    if (result.success) await refreshSession();
    return result;
  }, [refreshSession]);

  const refreshPremiumStatus = useCallback(async () => {
    await refreshSession();
  }, [refreshSession]);

  return {
    isPremium,
    isTrial,
    hasPremiumAccess,
    eligibleForTrial,
    premiumExpiresAt,
    trialEndsAt,
    requestTrial,
    activateTrial,
    refreshPremiumStatus,
  };
}
